"use strict";function t(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var i=t(require("styled-components")).default.ul`
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    list-style: none;
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 8px;
    margin: 0;
    padding: 0;
    z-index: 5;

    li {
        margin: 0;
        padding: 0;
        width: 6px;
        height: 6px;
        border-radius: 100%;
        background: ${({theme:t})=>t.colors.primary.light};
        opacity: 0.6;
        transition: all 0.4s ease-in-out;
        cursor: pointer;

        &.active {
            opacity: 1;
        }
    }
`;module.exports=i;
//# sourceMappingURL=styles.js.map
